import React from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'

export function CustomModal ({ children, isSubmitting, onCancel, onOk, title, okButtonProps = {}, cancelButtonProps = {}, ...rest }) {
  const { t } = useTranslation()
  return (
    <Modal onCancel={onCancel} onOk={onOk} title={title} okText={t('common.label.save')} cancelText={t('common.label.cancel')} okButtonProps={{ loading: isSubmitting, ...okButtonProps }} cancelButtonProps={{ disabled: isSubmitting, ...cancelButtonProps }} {...rest}>
      {children}
    </Modal>
  )
}
